import { Navigate, Route, Routes } from 'react-router-dom';

import { routes } from '@blockpulse3/data/shared';
import { UserSettingsView, VerifyEmailView } from '@blockpulse3/web-client/auth';
import {
  OnboardingExistingCompanyAccess,
  OnboardingExistingCompanyCreate,
  OnboardingExistingCompanyLayout,
  OnboardingExistingCompanyOwners,
  OnboardingExistingCompanyParameters,
  OnboardingExistingCompanyRepresentatives,
  OnboardingExistingCompanySummary,
  OnboardingSPVView,
} from '@blockpulse3/web-client/onboardings';
import { SPVView } from '@blockpulse3/web-client/spv-registry';

import { AppLayout, CenterLayout, EmptyLayout } from '../layouts';
import { AdminRoutes } from './AdminRoutes';
import { CompanyWorkspaceRoutes } from './CompanyWorkspaceRoutes';
import { UserWorkspaceRoutes } from './UserWorkspaceRoutes';
import { SwitcherModal, WorkspaceSwitcherContextProvider } from '@blockpulse3/web-client/sidebar';

type Props = unknown;

export function AppScreen(): JSX.Element {
  return (
    <WorkspaceSwitcherContextProvider>
      <SwitcherModal />
      <Routes>
        <Route element={<UserWorkspaceRoutes />} path={routes.me.href + '/*'} />
        <Route element={<CompanyWorkspaceRoutes />} path={routes.workspace.href + '/*'} />
        <Route element={<CenterLayout />}>
          <Route element={<VerifyEmailView />} path={routes.verifyEmail.href} />
        </Route>
        <Route element={<AdminRoutes />} path={routes.admin.href + '/*'} />
        <Route element={<AppLayout />}>
          <Route element={<UserSettingsView />} path={routes.me.settings.href} />
          <Route element={<SPVView />} path={routes.onboardings.spv.href} />
        </Route>
        <Route element={<EmptyLayout />}>
          <Route element={<OnboardingExistingCompanyLayout />}>
            <Route
              element={<OnboardingExistingCompanyCreate />}
              path={routes.onboardings.company.create.href}
            />
            <Route
              element={<OnboardingExistingCompanyParameters />}
              path={routes.onboardings.company.infos.href}
            />
            <Route
              element={<OnboardingExistingCompanyRepresentatives />}
              path={routes.onboardings.company.representatives.href}
            />
            <Route
              element={<OnboardingExistingCompanyOwners />}
              path={routes.onboardings.company.owners.href}
            />
            <Route
              element={<OnboardingExistingCompanyAccess />}
              path={routes.onboardings.company.access.href}
            />
            <Route
              element={<OnboardingExistingCompanySummary />}
              path={routes.onboardings.company.summary.href}
            />
          </Route>
          <Route element={<OnboardingSPVView />} path={routes.onboardings.spvEdit.href} />
          <Route element={<OnboardingSPVView />} path={routes.onboardings.spvCreate.href} />
        </Route>
        <Route element={<Navigate replace to={routes.me.href} />} path="*" />
      </Routes>
    </WorkspaceSwitcherContextProvider>
  );
}

export type AppScreenProps = Props;
